<template>
    <div class="user-info" v-if="!user.islogin">
        您尚未登录，<span @click="loginRef.Show">登录</span>
    </div>
    <div class="user-info" v-if="user.islogin && !user.rolename">
        欢迎您，<strong>{{ user.account }}</strong>
        <span @click="bindRef.Show">绑定角色</span
        ><span @click="logout">切换账号</span>
    </div>
    <div class="user-info" v-if="user.islogin && user.rolename">
        欢迎您，<strong>{{ user.account }}</strong
        >&nbsp;&nbsp;当前绑定：<strong>{{ user.rolename }}</strong>
        <span @click="logout">切换账号</span>
    </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { ref, inject } from "vue";
import useStore from "@/store/store";
const { logout } = useStore();
const { user } = storeToRefs(useStore());

const bindRef = inject("bindRef");
const loginRef = inject("loginRef");
</script>

<style lang="scss" scoped>
.user-info {
    display: flex;
    align-items: center;
    color: #e2a13e;
    span {
        padding: 6px 12px;
        font-size: 14px;
        background-color: #e2a13e;
        color: #462e1f;
        border-radius: 4px;
        cursor: pointer;
        margin-left: 12px;
        &:hover {
            background-color: #f0b45c;
            color: #462e1f;
        }
    }
}
</style>
